module.exports = __webpack_public_path__ + "static/media/nft-sports-icon1.c5e65096.svg";